"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const positives = ['true', '1', 1];
const negatives = ['false', '0', 0];
function toBoolean(value) {
    if (typeof (value) === 'boolean') {
        return value;
    }
    if (positives.includes(value)) {
        return true;
    }
    if (negatives.includes(value)) {
        return false;
    }
    return null;
}
exports.toBoolean = toBoolean;
